module.exports = __webpack_public_path__ + "static/media/RP-69.9397ff82.pdf";